/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {X_TOKEN, USER_TOKEN } from '@shared/utils.constant';
import { EncryptionService } from '../encryption.service';
// file unit test nya mana
// pake yg dar shared
@Injectable({
  providedIn: 'root'
})
export class TokenService {

  constructor(
    private encryptionService: EncryptionService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) { }

  isLoggedIn(): boolean | null {
    if (isPlatformBrowser(this.platformId)) {
      return this.getToken() as unknown as boolean;
    }
    return null;
  }

  hasValidToken(): boolean | null {
    return null;
  }

  getToken(): string {
    const encDataConst = this.encryptionService.encryptData(USER_TOKEN);
    let storage;
    if (typeof localStorage !== 'undefined') storage = localStorage.getItem(encDataConst as string);
    return this.encryptionService.decryptData(storage);
  }

  getXToken(): string {
    const encDataConst = this.encryptionService.encryptData(X_TOKEN);
    let xToken = this.encryptionService.decryptData(localStorage.getItem(encDataConst as string));
    if (xToken) {
      xToken = JSON.parse(xToken).token;
    }
    return xToken;
  }

  storeData(dataConst: string, dataValue: any, type: 'local' | 'session' = 'local') {
    if (dataConst !== null) {
      const encDataConst = this.encryptionService.encryptData(dataConst);
      const encDataValue = this.encryptionService.encryptData(dataValue);
      if (type === 'local') localStorage.setItem(encDataConst as string, encDataValue as string);
      if (type === 'session') sessionStorage.setItem(encDataConst as string, encDataValue as string);
    }
  }

  getData(dataConst: string, type: 'local' | 'session' = 'local') {
    if (dataConst !== null) {
      const encDataConst = this.encryptionService.encryptData(dataConst);
      if (type === 'local') {
        let storage;
        if (typeof localStorage !== 'undefined') storage = localStorage.getItem(encDataConst as string);
        return this.encryptionService.decryptData( storage);
      } else {
        return this.encryptionService.decryptData(
          sessionStorage.getItem(encDataConst as string)
        );
      }
    }
  }

  removeData(dataConst: string, type: 'local' | 'session' = 'local') {
    if (dataConst !== null) {
      const encDataConst = this.encryptionService.encryptData(dataConst);
      if (type === 'local') localStorage.removeItem(encDataConst as string);
      if (type === 'session') sessionStorage.removeItem(encDataConst as string);
    }
  }

  setToken(token: string): void {
    const encDataConst = this.encryptionService.encryptData(USER_TOKEN);
    const encDataValue = this.encryptionService.encryptData(token);
    localStorage.setItem(encDataConst as string, encDataValue as string);
  }

  removeToken(): void {
    const encDataConst = this.encryptionService.encryptData(USER_TOKEN);
    this.removeData('c-token');
    this.removeData('store-data');
    this.removeData('store-data-expiry');
    localStorage.removeItem(encDataConst as string);
  }
}
